module.exports = __webpack_public_path__ + "img/SMT_34_Ms_Dolly_Cheng.daaebbea.jpg";